import pageStyle from "./index.module.less";
import * as service from "@/views/ticket/service";

export default {
    name: "Account_status",
    data: () => {
        return {
            pageStyle,
            showAll: false,
            loading: false,
            unban_time: "underfined",
            status: "underfined",
            language: ""
        };
    },
    props: {
        value: {
            type: [Object, Array],
            default: () => ({})
        }
    },
    computed: {},
    created() {},
    methods: {
        async seeAccountStatus(val) {
            if (val == false) {
                this.loading = true;
                const { unban_time, status } = await service.punish_status({
                    time_zone: this.value.time_zone,
                    open_id: this.value.open_id,
                    system_id: this.value.system_id,
                    game_id: this.value.game_id
                });
                this.unban_time = unban_time;
                this.status = status;
                this.showAll = true;
                this.loading = false;
            } else {
                this.showAll = false;
            }
        }
    },
    watch: {
        "$i18n.locale": {
            handler(value) {
                this.language = value;
            },
            immediate: true
        },
        value() {
            this.showAll = false;
        }
    }
};
